// Google Form Configuration
// Replace these with your actual Google Form details

export const googleFormConfig = {
  // Your actual Google Form URL
  formUrl: 'https://forms.gle/WTf8TTULj9vTXg1g6',
  
  // Your Google Form submission action URL - THIS NEEDS TO BE EXTRACTED FROM YOUR FORM
  // To find this: Open your form → Press F12 → Look for the form action attribute
  actionUrl: 'https://docs.google.com/forms/d/e/YOUR_FORM_ID_HERE/formResponse',
  
  // Field mapping - THESE NEED TO BE REPLACED WITH YOUR ACTUAL FIELD IDs
  // To find these: Open your form → Press F12 → Search for 'entry.' in Elements tab
  fieldMapping: {
    fullName: 'entry.YOUR_NAME_FIELD_ID',        // Field for Name (required)
    email: 'entry.YOUR_EMAIL_FIELD_ID',         // Field for Email (required)
    phone: 'entry.YOUR_PHONE_FIELD_ID',         // Field for Phone No (required)
    travelDate: 'entry.YOUR_DATE_FIELD_ID',     // Field for Date (required)
    travellerCount: 'entry.YOUR_COUNT_FIELD_ID', // Field for Count (required)
    message: 'entry.YOUR_MESSAGE_FIELD_ID'       // Field for Message (required)
  }
};

// DEBUG FUNCTION: Run this in browser console on your form page to find field IDs
export const findFormFields = () => {
  const form = document.querySelector('form');
  if (form) {
    console.log('Form action URL:', form.action);
    
    const inputs = form.querySelectorAll('input[name*="entry."]');
    inputs.forEach(input => {
      console.log(`Field ID: ${input.name}, Type: ${input.type}, Label: ${input.getAttribute('aria-label') || 'Unknown'}`);
    });
  }
};
